import {
  OperationsModulePermissions as Permissions,
  OperationsRoutes as Routes,
} from '../../constants/operations.constants';
import { QuotaArea } from './quota-navigation.models';

export const quotaAreas: readonly QuotaArea[] = [
  {
    label: 'Allowances',
    pagesLabel: 'Allowance pages',
    pages: [
      {
        label: 'Allocations & delivery',
        route: Routes.benefitDeliveries,
        permissions: Permissions.benefitDeliveries,
      },
      {
        label: 'Grants',
        route: Routes.benefitGrants,
        permissions: Permissions.benefitGrants,
      },
      {
        label: 'Processing failures',
        route: Routes.benefitRecovery,
        permissions: Permissions.benefitRecovery,
      },
    ],
  },
  {
    label: 'Usage',
    pages: [
      {
        label: 'Storage',
        route: Routes.storageUsage,
        permissions: Permissions.storageUsage,
      },
      {
        label: 'LLM',
        route: Routes.llmQuotas,
        permissions: Permissions.llmQuotas,
      },
    ],
  },
  {
    label: 'Funding',
    pages: [
      {
        label: 'Funding',
        route: Routes.serviceFunding,
        permissions: Permissions.serviceFunding,
      },
    ],
  },
  {
    label: 'Pricing',
    pagesLabel: 'Pricing services',
    pages: [
      {
        label: 'LLM',
        route: Routes.llmPricing,
        permissions: Permissions.llmPricing,
      },
      {
        label: 'Communication',
        route: Routes.communicationPricing,
        permissions: Permissions.communicationPricing,
      },
      {
        label: 'Storage',
        route: Routes.storagePricing,
        permissions: Permissions.storagePricing,
      },
    ],
  },
  {
    label: 'Collections',
    pages: [
      {
        label: 'Collections',
        route: Routes.quotaCollections,
        permissions: Permissions.quotaCollections,
      },
    ],
  },
];
